import React from 'react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Radio,
  Typography,
} from '@mui/material';

const PopupEscolhaCadastro = ({
  showPopupEscolha,
  setShowPopupEscolha,
  escolhaCadastro,
  setEscolhaCadastro,
  setPrecisaResponsavel,
  setShowIJMForm,
}) => (
  <Dialog
    open={showPopupEscolha}
    onClose={() => setShowPopupEscolha(false)}
    maxWidth='sm'
    fullWidth
  >
    <DialogTitle>Como deseja prosseguir?</DialogTitle>
    <DialogContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card
            sx={{
              p: 3,
              cursor: 'pointer',
              border: escolhaCadastro === 'mocidade' ? 2 : 1,
              borderColor:
                escolhaCadastro === 'mocidade' ? 'primary.main' : 'divider',
              '&:hover': { borderColor: 'primary.main' },
            }}
            onClick={() => {
              setEscolhaCadastro('mocidade');
              setPrecisaResponsavel(false);
              setShowIJMForm(false);
              setShowPopupEscolha(false);
            }}
          >
            <Box display='flex' alignItems='center' gap={2}>
              <Radio checked={escolhaCadastro === 'mocidade'} />
              <Box>
                <Typography variant='h6' fontWeight='bold'>
                  Cadastro para Mocidade
                </Typography>
                <Typography color='textSecondary'>
                  Quero me matricular em um curso IJM
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card
            sx={{
              p: 3,
              cursor: 'pointer',
              border: escolhaCadastro === 'menor' ? 2 : 1,
              borderColor:
                escolhaCadastro === 'menor' ? 'primary.main' : 'divider',
              '&:hover': { borderColor: 'primary.main' },
            }}
            onClick={() => {
              setEscolhaCadastro('menor');
              setPrecisaResponsavel(true);
              setShowIJMForm(true);
              setShowPopupEscolha(false);
            }}
          >
            <Box display='flex' alignItems='center' gap={2}>
              <Radio checked={escolhaCadastro === 'menor'} />
              <Box>
                <Typography variant='h6' fontWeight='bold'>
                  Cadastrar um Menor
                </Typography>
                <Typography color='textSecondary'>
                  Quero cadastrar uma criança/jovem
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setShowPopupEscolha(false)}>Cancelar</Button>
      <Button
        variant='contained'
        onClick={() => {
          setShowPopupEscolha(false);
          if (escolhaCadastro === 'mocidade') {
            setPrecisaResponsavel(false);
            setShowIJMForm(false);
          } else {
            setPrecisaResponsavel(true);
            setShowIJMForm(true);
          }
        }}
        disabled={!escolhaCadastro}
      >
        Continuar
      </Button>
    </DialogActions>
  </Dialog>
);

export default PopupEscolhaCadastro;
